import { Static, Type } from '@sinclair/typebox';

export const DeviceInfoHeaderSchema = Type.Object({
  'x-client-os': Type.String(),
  'x-client-device': Type.String(),
  'x-client-version': Type.String(),
});
export type DeviceInfoHeader = Static<typeof DeviceInfoHeaderSchema>;

export const AuthSessionHeaderSchema = Type.Object({
  'x-client-os': Type.String(),
  'x-client-device': Type.String(),
  'x-client-version': Type.String(),
  'x-app-version': Type.Optional(Type.String()),
});
export type AuthSessionHeader = Static<typeof AuthSessionHeaderSchema>;
